import {
  getFileExtension,
  getFileExtensionFromMimeType,
  isAudio,
  isImage,
  isVideo,
} from "@/libs/file-helper";

export type AttachmentKind = "image" | "video" | "audio" | "other";

/**
 * The extension a file is judged by: its name first, then its URI (CDN links often carry
 * one the name lacks), then its MIME type.
 */
export function resolveAttachmentExtension(file: {
  fileName?: string | null;
  originalContentUri?: string | null;
  contentType?: string | null;
}): string {
  return (
    getFileExtension(file.fileName ?? "") ||
    getFileExtension(file.originalContentUri ?? "") ||
    getFileExtensionFromMimeType(file.contentType ?? "")
  );
}

/**
 * What a file IS, for the tile. The MIME type wins over the extension where the two can
 * disagree: a `.webm` is a video from a camera but audio from the voice recorder, and a
 * picked file's `File.type` (or the CDN object's content type) says which.
 */
export function classifyAttachmentKind(
  fileExtension: string,
  contentType?: string | null,
): AttachmentKind {
  const mime = (contentType ?? "").toLowerCase();
  if (mime.startsWith("audio/") || isAudio(fileExtension)) return "audio";
  if (mime.startsWith("video/") || isVideo(fileExtension)) return "video";
  if (mime.startsWith("image/") || isImage(fileExtension)) return "image";
  return "other";
}
